/**
*  Copyright (c) 2020 Micro Focus Software Inc.  All Rights Reserved.
*
* THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
* AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
* WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
* TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
* AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
* INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
* PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
* CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
* OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
* ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
* THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
*/


import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BannerComponent } from './banner.component';
import { HomeAuthGuard } from '../../../shared/guard/homeauth.guard';
import { CommonRouteGuard } from '../../../shared/guard/commonrouteguard';
import { CommonConstants } from '../../../common/constants/common-constants';


const routes: Routes = [
  {
    path: '', component: BannerComponent,
    children: [
      {
        path: 'store',
        canActivate: [CommonRouteGuard],
        loadChildren: () => import('../../feature/store/store.module').then(m => m.StoreModule),
        data: {
          tab: CommonConstants.STORE_COMPONENT
        }
      },
      {
        path: 'requests',
        canActivate: [CommonRouteGuard],
        loadChildren: () => import('../../feature/requests/requests.module').then(m => m.RequestsModule),
        data: {
          tab: CommonConstants.REQUEST_COMPONENT
        }
      },
      {
        path: 'services',
        canActivate: [CommonRouteGuard],
        loadChildren: () => import('../../feature/serviceitems/serviceitems.module').then(m => m.ServiceItemsModule),
        data: {
          tab: CommonConstants.SERVICES_COMPONENT
        }
      },
      {
        path: 'items',
        canActivate: [CommonRouteGuard],
        loadChildren: () => import('../../feature/items/items.module').then(m => m.ItemsModule),
        data: {
          tab: CommonConstants.ITEMS_COMPONENT
        }
      },
      {
        path: 'selfhelp',
        loadChildren: () => import('../../feature/selfhelp/selfhelp.module').then(m => m.SelfHelpModule),
      },
      {
        path: 'outages',
        loadChildren: () => import('../../feature/outages/outages.module').then(m => m.OutagesModule),
      },
      {
        path: 'survey',
        loadChildren: () => import('../../feature/survey/survey.module').then(m => m.SurveyModule),
      },
      {
        path: 'my-profile',
        loadChildren: () => import('../userprofile/userprofile.module').then(m => m.UserProfileModule),
      },
      {
        path: 'search',
        loadChildren: () => import('../searchresult/searchresult.module').then(m => m.SearchModule),
      },
      {
        path: 'newrequest',
        loadChildren: () => import('../../feature/newrequest/newrequest.module').then(m => m.NewRequestModule),
      },
      {
        path: 'proposedsolution',
        loadChildren: () => import('../../feature/newrequest/proposedsolution/proposedsolution.module').then(m => m.ProposedSolutionModule),
      },
      {
        path: 'home',
        loadChildren: () => import('../home/home.module').then(m => m.HomeModule),
      },
      {
        path: 'report-incident',
        canActivate: [CommonRouteGuard],
        loadChildren: () => import('../../feature/newrequest/reportincident/reportincident.module').then(m => m.ReportIncidentModule),
        data: {
          tab: CommonConstants.REPORT_INCIDENT_COMPONENT
        }
      },
      {
        path: '**',
        canActivate: [HomeAuthGuard],
        pathMatch: 'full'
      },
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class BannerRoutingModule { }
